import { Environment, getHostname, isCloverStagingEnvironment, isDevHost } from 'util/Environment';

export const OLO_APPLE_PAY_TOKEN = 'APPLE_PAY';
export const APPLE_PAY_VERSION = 3;

export const nonProdIdentifiers: Readonly<Partial<Record<Environment, string>>> = {
  test: 'merchant.com.clover.dev1.web.applepay',
  development: 'merchant.com.clover.dev1.web.applepay'
};

export const prodIdentifiers: Readonly<Record<string, string>> = {
  www: 'merchant.com.clover.prod.web.applepay',
  dev1: 'merchant.com.clover.dev1.web.applepay',
  sandbox: 'merchant.com.clover.sandbox.web.applepay',
  stg1: 'merchant.com.clover.stg1.web.applepay',
  stg7: 'merchant.com.clover.stg7.web.applepay',
  staging: 'merchant.com.clover.staging.web.applepay'
};

export const getIdentifier = (environment: Environment): string => {
  if (environment !== 'production') {
    const identifier = nonProdIdentifiers[environment];

    if (identifier) return identifier;
  }

  // return dev1 script url for netlify or any other dev host
  if (isDevHost()) return prodIdentifiers['dev1'];

  const isStaging = isCloverStagingEnvironment() && getHostname().includes('staging');

  const hostname = !isStaging ? getHostname().split('.')[0]: 'staging';

  // eslint-disable-next-line @typescript-eslint/prefer-includes
  if (Object.keys(prodIdentifiers).indexOf(hostname) < 0) {
    window.console.error(`Apple Pay merchant identifier not configured for ${hostname} environment`);
  }

  return prodIdentifiers[hostname];
};
